export const colorMap: Record<string, string> = {
  zwart: "#1a1a1a",
  bruin: "#8B4513",
  roze: "#E8A0AE",
  rood: "#CC3333",
  paars: "#7B2D8B",
  blauw: "#4169E1",
  groen: "#2E8B57",
  grijs: "#808080",
  oranje: "#E8752A",
  huidskleur: "#D4A574",
  "wit-creme": "#F5F0E0",
  transparant: "transparent",
};
